import React from 'react';

import classnames from 'classnames/bind';

import { AdminDocumentListItem } from '@SERVICES';

import Document from '@PAGES/admin/documents-list/components/Document';

import styles from './Content.module.scss';

const cx: CX = classnames.bind(styles);

function Content(props: Props) {
    const { documentsData } = props;

    return (
        <div className={cx('content')}>
            <div className={cx('grid')}>
                {
                    documentsData.map((doc) => {
                        const key = doc.data.id;

                        return (
                            <div
                                key={key}
                                className={cx('grid-item')}
                            >
                                <Document doc={doc} />
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
}

type Props = {
    documentsData: AdminDocumentListItem[],
};

export default Content;
